import * as React from 'react';

export default function useSetInitialScrollTop() {
    const scrollRegion = React.useRef<HTMLDivElement>();

    React.useLayoutEffect(() => {
        if (scrollRegion.current) {
            scrollRegion.current.scrollTop = 0;
        }
    });

    return React.useCallback((ref: HTMLDivElement) => {
        if (ref?.parentElement) {
            scrollRegion.current = ref as HTMLDivElement;
        }
    }, []);
}
